import { useEffect, useState } from 'react';

import { localStore } from '~src/state/local';
import { useLocation } from './useLocation';

export const useEnvironment = () => {
  const [environment, setEnvironment] = useState({
    isDebug: false,
    isLocalhost: true,
    isProduction: false,
    isStaging: false,
  });

  const { location } = useLocation();

  const { href } = location ?? {};

  useEffect(() => {
    const isDebug = localStore().get('debug') === 'true';
    const isLocalhost = !!href?.includes('localhost');
    const isStaging = !!href?.includes('staging');
    const isProduction = !isLocalhost && !isStaging;

    setEnvironment({ isDebug, isLocalhost, isProduction, isStaging });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return environment;
};
